<template>
	<b-container fluid class="mt-4">
		<p><router-link to="/character-importer">Back to Guide List</router-link></p>
		<h2>FarmD Character Importer: {{tutorialDisplayName}}</h2>
		<component :is="tutorialContent" />
	</b-container>
</template>

<script>
	import Installation from './Installation';
	import RigRequirements from './RigRequirements';
	import ModelExportAndImport from './ModelExportAndImport';
	import BasicInfoModule from './BasicInfoModule';
	import LimbSetupModule from './LimbSetupModule';
	import HandAndFingerModule from './HandAndFingerModule';
	import MaterialsAndTexturesModule from './MaterialsAndTexturesModule';
	import ConfigurablePartsModule from './ConfigurablePartsModule';
	import CollidersModule from './CollidersModule';
	import ExpressionsModule from './ExpressionsModule';
	import TailModule from './TailModule';
	import CockModule from './CockModule';
	import PenetrablesModule from './PenetrablesModule';
	import TouchTargetsModule from './TouchTargetsModule';
	import SoftbodyModule from './SoftbodyModule';
	import EquipmentModule from './EquipmentModule';
    
export default {
	name: 'Tutorials',
	components: {
        Installation
	},
	computed: {
		tutorialContent() {
			var tutorials = {
				"Installation": Installation,
				"RigRequirements": RigRequirements,
				"ModelExportAndImport": ModelExportAndImport,
				"BasicInfoModule": BasicInfoModule,
				"LimbSetupModule": LimbSetupModule,
				"HandAndFingerModule": HandAndFingerModule,
                "MaterialsAndTexturesModule": MaterialsAndTexturesModule,
				"ConfigurablePartsModule": ConfigurablePartsModule,
				"CollidersModule": CollidersModule,
				"ExpressionsModule": ExpressionsModule,
				"TailModule": TailModule,
				"CockModule": CockModule,
				"PenetrablesModule": PenetrablesModule,
				"TouchTargetsModule": TouchTargetsModule,
				"SoftbodyModule": SoftbodyModule,
				"EquipmentModule": EquipmentModule,
			}

			return tutorials[this.$route.params.tutorialName];
		},
		tutorialDisplayName() {
			return this.$route.params.tutorialName.replace(/([A-Z])/g, ' $1').trim();
        }
    }
}
</script>

<style>
	p {
		font-size: 1.2em;
	}

	@media (min-width: 992px) {
		p {
			margin-right: 20%;
		}
	}

	body {
		margin-bottom: 100px
	}
</style>
